









































































import { Component, Vue, Inject} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax'
import AbpBase from '../../../../lib/abpbase'
import ProjectManage from '../projectManage.vue'
import advancedSearch from '../../../../components/tools/advancedSearch.vue'  
@Component({
    name:'projectList',
    components: {
        ProjectManage,
        advancedSearch
    }
})
export default class ProjectList extends AbpBase  {
    searchInfo:any = {
        ProjectName: null,
        BearerOrgId: null,
        Status: null,
        Ascending:null,
        Sorting:null
    }
    advancedSearchType:any = {
        type:'project',
        data:this.searchInfo
    }
    tableData:any = {
        title: [
            {
                title: '项目编号',
                key: 'projectCode',
                width: 150,
                align: 'center'
            },
            {
                title: '项目名称',
                key: 'projectName',
                minWidth: 450,
                align: 'left',
                className: 'font-blue',
                render: (h:any,params:any) => {
                    return h('a',{
                        on:{
                            click: ()=> {
                                this.ToDetail(params.row);
                            }
                        }
                    },params.row.projectName)
                }
            },
            {
                title: '合同编号',
                key: 'contractNumber',
                width: 150,
                align: 'center',
                sortable: 'custom'
            },
            {
                title: '项目承担部门',
                key: 'bearerOrg',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.bearerOrg ? params.row.bearerOrg.displayName : '')
                    ])
                }
            },
            {
                title: '二级部门',
                key: 'secondBearerOrg',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.secondBearerOrg ? params.row.secondBearerOrg.displayName : '')
                    ])
                }
            },
            {
                title: '负责人',
                key: 'auditLeader',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.auditLeader ? params.row.auditLeader.name : '')
                    ])
                }
            },
            {
                title: '项目填报时间',
                key: 'creationTime',
                width: 150,
                align: 'center',
                sortable: 'custom',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, new Date(params.row.creationTime).getFullYear() + '年' + (new Date(params.row.creationTime).getMonth()+1) + '月')
                    ])
                }
            },
            {
                title: '项目状态',
                key: 'statusDesc',
                width: 150,
                align: 'center'
            },
            {
                title: '委托单位',
                key: 'entrustmentUnit',
                width: 250,
                align: 'center'
            },
            {
                title: '项目性质',
                key: 'natureDesc',
                width: 150,
                align: 'center'
            },
            {
                title: '资金来源',
                key: 'fundsSourceDesc',
                width: 150,
                align: 'center'
            },
            {
                title: '工期',
                key: 'time',
                width: 180,
                align: 'center',                    
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, new Date(params.row.beginDt).getFullYear() + '年' + (new Date(params.row.beginDt).getMonth()+1) + '月' + '-' + new Date(params.row.endDt).getFullYear() + '年' + (new Date(params.row.endDt).getMonth()+1) + '月')
                    ])
                }
            },
            {
                title: '项目经费（万元）',
                key: 'projectAmountFormat',
                width: 150,
                align: 'center',
                sortable: 'custom'
            },
            {
                title: '已收款（万元）',
                key: 'totalReceiptsFormat',
                width: 150,
                align: 'center',
                sortable: 'custom'
            },
            {
                title: '未收款（万元）',
                key: 'unreceivableFormat',
                width: 150,
                align: 'center',
                sortable: 'custom'
            },
            {
                title: '开票未收款（万元）',
                key: 'tickUnAmountFormat',
                width: 180,
                align: 'center',
                sortable: 'custom'
            },
            {
                title: '开票信息',
                key: 'area',
                width: 250,
                align: 'center',
                render: (h:any, params:any)=>{
                    let arr:any = [];
                    if(params.row.unTickets){
                        params.row.unTickets.map( (item:any) => {
                            let str = "";
                            arr.push(h('Col', {},new Date(item.ticketDt ).getFullYear() + '年' + (new Date(item.ticketDt ).getMonth()+1) + '月'+ (new Date(item.ticketDt ).getDate()) + '日' +'   '+ item.ticketAmountWyFormat +'万元' ));
                        } )
                    }
                    return h('Row', arr);
                }
            },
            {
                title: '收款责任人',
                key: 'tickGatherLeader',
                width: 150,
                align: 'center'
            },
            {
                title: '行政区划',
                key: 'area',
                width: 200,
                align: 'center',
                render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, (params.row.city ?params.row.city.name : '')+(params.row.county ? '/' + params.row.county.name : '')+(params.row.province?  '/' +params.row.province.name: '')  )
                        ])
                }
            }
        ],
        content: [],
        loading: true,
        newTitle:[]
    }
    initData:any = {
        column:{   //自定义显示列
            visible:false,
            dropdownCheckAllGroup:[],
            indeterminate:false,
            checkAll:true, //是否全选 true:全 false:不
            dropdownCheckAllList:[],//自定义列的列表
        },
        bearerUnitPartId: [],
        allDictionary: {},
        totalCount: null,
        showAdvancedSearch: false,
        currentName:'projectList',
        userInfo:{}, // 用户信息
    }
    
    dropdownHandleOpen () { //自定义显示列显示隐藏
        this.initData.column.visible = !this.initData.column.visible;
    }
    dropdownHandleCheckAll(){  //自定义列全选
        this.initData.column.dropdownCheckAllGroup = [];
        if (this.initData.column.indeterminate) {
            this.initData.column.checkAll = false;
        } else {
            this.initData.column.checkAll = !this.initData.column.checkAll;
        }
        this.initData.column.indeterminate = false;
        if (this.initData.column.checkAll) {
            this.tableData.title.forEach((item:any,index:any) => {
                this.initData.column.dropdownCheckAllGroup.push(item.key)
            });
            this.initData.column.dropdownCheckAllList.map( (item:any) => {
                return item.isVisiblity = true;
            } )
        } else {
            this.initData.column.dropdownCheckAllGroup = [];
            this.initData.column.dropdownCheckAllList.map( (item:any) => {
                return item.isVisiblity = false;
            } )
        }
    }
    dropdownCheckAllGroupChange(res:any){  //自定义列单选
        if (res.length === this.initData.column.dropdownCheckAllList.length) {
            this.initData.column.indeterminate = false;
            this.initData.column.checkAll = true;
        } else if (res.length > 0) {
            this.initData.column.indeterminate = true;
            this.initData.column.checkAll = false;
        } else {
            this.initData.column.indeterminate = false;
            this.initData.column.checkAll = false;
        }
        //获取得到的值
        this.initData.column.dropdownCheckAllList.map( (item:any) => {
            let bool:any = false;
            res.forEach( (val:any) => {
                if(item.fieldEnName == val){
                    bool = true;
                }
            } )
            if(!bool){
                return item.isVisiblity = false;
            }else{
                return item.isVisiblity = true;
            }
        } )
    }
    async saveDropdownColumn(){//保存列
    console.log(this.initData.column.dropdownCheckAllList)
    // return;
        await Ajax.post('/api/services/app/UserHabits/SaveZGBProjectLedgerAsync',this.initData.column.dropdownCheckAllList);
        await this.$store.dispatch('session/GetCurrentLoginInformations');
        await this.setDropdownCheckAllList();
        this.initData.column.visible = false;
    }
    setDropdownCheckAllList(){//设置初始化的列
        this.initData.column.dropdownCheckAllGroup = [];
        if(this.$store.state.session.userHabits.ledger.zgbProjectLedger.length){
            this.initData.column.dropdownCheckAllList = this.$store.state.session.userHabits.ledger.zgbProjectLedger;
            //判断是否有项目编号
            var isHave =  this.initData.column.dropdownCheckAllList.filter( (item:any) => {
                return item.fieldEnName == 'projectCode'
            } )
            if(!isHave.length){
                this.initData.column.dropdownCheckAllList.push({
                    fieldEnName:'projectCode',
                    fieldZhName:'项目编号',
                    isVisiblity:true,
                    isFixed:false,
                })
            }
            this.$store.state.session.userHabits.ledger.zgbProjectLedger.forEach( (item:any) => {
                if(item.isVisiblity){
                    this.initData.column.dropdownCheckAllGroup.push(item.fieldEnName);
                }
            } )
            //设置全选按钮
            if (this.initData.column.dropdownCheckAllGroup.length === this.initData.column.dropdownCheckAllList.length) {
                this.initData.column.indeterminate = false;
                this.initData.column.checkAll = true;
            }else{
                this.initData.column.indeterminate = true;
                this.initData.column.checkAll = false;
            }
        }else{
            this.tableData.title.forEach((item:any,index:any) => {
                // if(index != 0){
                this.initData.column.dropdownCheckAllList.push({
                    fieldEnName:item.key,
                    fieldZhName:item.title,
                    isVisiblity:true,
                    isFixed:false,
                })
                this.initData.column.dropdownCheckAllGroup.push(item.key);
                // }
            });
        }
        this.changeColumn();
    }
    changeColumn(){ // 改变列
        let data:any = [];
        let ind = null;
        this.tableData.title.forEach( (item:any) => {
            this.initData.column.dropdownCheckAllGroup.forEach( (val:any,index:any) => {
                if(item.key == val){
                    data.push(item);
                }
            } )
        } )
        console.log(this.initData.userInfo)
        if(this.initData.userInfo.organization.displayName != '三所' &&  this.initData.userInfo.name != "admin") {
            data.forEach( (item:any,index:any) =>{
                if(item.title == "开票信息"){
                    ind = index;
                }
            } )
            data.splice(ind,1);
        }
        this.tableData.newTitle = data;
    }
    //高级搜索
    ShowSearch() {
        (this as any).$refs.advancedSearch.Show(!this.initData.showAdvancedSearch);
        this.initData.showAdvancedSearch = !this.initData.showAdvancedSearch;
    }
    AdvancedSearch(data:any) {
        Object.assign(this.searchInfo, data);
        this.GetData();
    }
    ClearSearch() {
        this.searchInfo = {};
    }
    //项目填报
    Add() {
        (this as any).reloadComponent('projectAdd');
        this.$nextTick( ()=>{
            this.$router.push({
                name: 'projectAdd'
            })
        } ) 
    }
    //跳转详情
    ToDetail(e:any) { 
        (this as any).reloadComponent('projectDetail');
        this.$nextTick( () => {    
            this.$router.push({
                name: 'projectDetail',
                query: {
                    id: e.id
                }
            })
        } ) 
    }
    //排序
    async changeSort(data:any){
        this.searchInfo.Sorting = data.key.replace(/( |^)[a-z]/g, (L:string) => L.toUpperCase()).replace('Format','');
        if(this.searchInfo.Sorting == "ContractNumber"){
            this.searchInfo.Sorting = "ContractSerialNumber";
        }
        if(data.order == 'asc'){
            this.searchInfo.Ascending = true;
        }else if(data.order == 'desc') {
            this.searchInfo.Ascending = false;
        }else{
            this.searchInfo.Ascending = null;
            this.searchInfo.Sorting = null;
        }
        this.GetData();
    }
    //获取表格数据
    async GetData() {
        this.tableData.loading = true;
        //下拉框选择全部时，处理数据
        this.searchInfo.BearerOrgId = this.searchInfo.BearerOrgId == -999 ? null : this.searchInfo.BearerOrgId;
        this.searchInfo.Status = this.searchInfo.Status == -999 ? null : this.searchInfo.Status;
        let temp = (await Ajax.get('/api/services/app/ProjectManager/GetAll', {params: this.searchInfo})).data.result;
        console.log(temp)
        if(!temp.items.length) this.$Message.error('暂无数据');
        this.tableData.content = temp.items;
        this.initData.totalCount = temp.totalCount;
        //加载
        this.tableData.loading = false;
    }
    //获取字典数据，填充到搜索框的组件内
    async FormDicData() {
        if(this.$store.state.project.allDictionary.length == 0){
            await this.$store.dispatch({
                type:'project/GetAllDictionary'
            })
        }
        //格式化
        this.$store.state.project.allDictionary.map((item:any) => {
            this.initData.allDictionary[item.key] = item.items.map((items:any) => {
                return {
                    label: items.displayName,
                    value: items.id
                }
            });
        })
        //下拉框添加空选项
        this.initData.allDictionary.ProjectStatus.unshift({
            label: '全部状态',
            value: '-999'
        });
    }
    //单位联动获取部门数据
    async GetDepart(){
        this.initData.bearerUnitPartId = (await Ajax.get('/api/services/app/Organization/GetBearOrganization')).data.result.map((item:any) => {
            return { label: item.displayName, value: item.id}
        })
        this.initData.bearerUnitPartId.unshift({
            label: '所有部门',
            value: '-999'
        });
    }
    //提交搜索数据
    Submit() {
        this.GetData();
    }
    //分页获取数据
    ChangePage(page:any) {
        this.searchInfo.SkipCount = page-1;
        this.GetData()
    }
    //切换每页条数
    ChangePageNum(perPage:any){
        this.searchInfo.MaxResultCount = perPage;
        this.GetData()
    }
    //导出
    Export() {
        (this as any).$root.Export(this.searchInfo, '/api/File/ExportProjectByPageAsync', '新建项目台账', 'xlsx');
    }
    //导出所有搜索结果
    ExportAll() {
        (this as any).$root.Export(this.searchInfo, '/api/ProjectFile/ExportAllProjectAsync', '新建项目台账', 'xlsx');
    }
    
    async mounted() {
        this.FormDicData();
        this.GetDepart();
        await this.GetData();
        // 获取当前登录用户信息
        this.initData.userInfo = this.$store.state.session.user;
        console.log(this.initData.userInfo)
        this.setDropdownCheckAllList();
        console.log(this.exceptFloatNum(1.2,10000))
    }
    exceptFloatNum(num1:any,num2:any){
        let len1 = 0;
        let len2 = 0;
        let intNum1;
        let intNum2;
        try{    
            len1 = (num1.toString()).split('.')[1].length;
        }catch(e){

        }
        try{    
            len2 = (num2.toString()).split('.')[1].length;
        }catch(e){
            
        }
        intNum1 = Number((num1.toString()).replace('.',''));
        intNum2 = Number((num2.toString()).replace('.',''));
        console.log(intNum1/intNum2)
        console.log(Math.pow(10,len2-len1))
        return (intNum1/intNum2)*Math.pow(10,len2-len1);
    }
    activated(){
        this.initData.currentName = 'projectList';
    }
}
